import { api } from '@/lib/api'

export function getCompanyTypes(country?: string) {
  return api.get<string[]>(`/v1/signup/company-types?country=${country}`)
}
